import { render, staticRenderFns } from "./StockBrowser.vue?vue&type=template&id=596cb937&"
import script from "./StockBrowser.vue?vue&type=script&lang=js&"
export * from "./StockBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports